import LocationHierarchy from './LocationHierarchy';

export default LocationHierarchy;
